export const NOTIFICATIONS_FEATURE_KEY = 'notifications'
export const ANALYTICS_REPORT_FEATURE_KEY = 'analytics-report'
export const ANALYTICS_REPORT_PARAM_TITLE = `${ANALYTICS_REPORT_FEATURE_KEY}.active`
export const NOTIFICATIONS_PARAM_TITLE = `${NOTIFICATIONS_FEATURE_KEY}.email`

export type IAnalyticsFrequencyKey = 'daily' | 'weekly' | 'monthly'

export const FREQUENCY_KEYS: IAnalyticsFrequencyKey[] = ['daily', 'weekly', 'monthly']
export const ANALYTICS_FREQUENCY_ITEMS = FREQUENCY_KEYS.map((id) => ({
  id,
  label: id[0].toUpperCase() + id.slice(1),
}))
